export { LinkFromHeaderContentLagoon } from './LinkFromHeaderContentLagoon';
